// extracted by mini-css-extract-plugin
export var dataCell = "_r1-2";
export var dataRow = "_r1-0";
export var headerRow = "_r1-1";